<template>
  <v-card
    :style="{
      'border-radius': '5px',
      border:
        '1px solid' + $store.getters.getColorPalette().panelBorderColorCode,
    }"
    flat
    :dark="$store.getters.getColorPalette().isDark"
  >
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$store.getters.getTextMap().search"
        single-line
        hide-details
        :dark="$store.getters.getColorPalette().isDark"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="maps"
      item-key="query_id"
      :search="search"
      :single-expand="true"
      show-expand
      :expanded.sync="expanded"
      :loading="loading"
      loading-text="Loading... Please wait"
      :dark="$store.getters.getColorPalette().isDark"
    >
      <template v-slot:top>
        <v-toolbar flat :dark="$store.getters.getColorPalette().isDark">
          <v-toolbar-title
            >{{ $store.getters.getTextMap().query }}
            {{ $store.getters.getTextMap().param }}
            {{ $store.getters.getTextMap().map }}
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <CreateQueryParamMapModal
            v-if="
              $store.state.user &&
              $store.state.settingMode &&
              $store.getters.getAccessByLevels(['engineeraccess'])
            "
          />
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <QueryParamMap :queryParamMap="item" />
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import CreateQueryParamMapModal from "@/components/modals/derived/CreateQueryParamMapModal";
import QueryParamMap from "@/components/items/derived/QueryParamMap";

export default {
  name: "QueryParamMapTable",
  components: {
    CreateQueryParamMapModal,
    QueryParamMap,
  },
  data() {
    return {
      search: "",
      loading: false,
      expanded: [],
      headers: [
        {
          text: "ID",
          align: "start",
          filterable: false,
          value: "query_id",
          class:
            " text-capitalize font-weight-black " +
            this.$store.getters.getColorPalette().tableHeaderColorName,
        },
        {
          text: "Name",
          value: "name",
          class:
            " text-capitalize font-weight-black " +
            this.$store.getters.getColorPalette().tableHeaderColorName,
        },
      ],
    };
  },
  computed: {
    maps() {
      return this.$store.getters.getQueryParamMaps();
    },
  },
};
</script>
<style scoped>
.v-card__title {
  background-color: #bdbdbd00;
}
.theme--light.v-toolbar.v-sheet {
  background-color: #b2dfdb00;
}
.theme--light.v-data-table {
  background-color: #b2dfdb00;
}
</style>
